<template>
  <v-app>
    <confirmDlg ref="confirm"></confirmDlg>
    <messageDlg ref="message"></messageDlg>
    <loaderDlg ref="loader"></loaderDlg>
    <v-content>
      <router-view />
    </v-content>
    <RwFooter />
  </v-app>
</template>

<script>
import RwFooter from "@/components/Footer.vue";
import confirmDlg from "@/components/ConfirmDlg.vue";
import messageDlg from "@/components/MessageDlg.vue";
import loaderDlg from "@/components/Loader.vue";

export default {
  name: "App",

  components: {
    RwFooter,
    confirmDlg,
    messageDlg,
    loaderDlg
  },

  data: () => ({
    //
  }),
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$message = this.$refs.message.open;
    this.$root.$loading = this.$refs.loader.show;
    this.$root.$loaded = this.$refs.loader.hide;
  }
};
</script>
